export default "__VITE_ASSET__DhUR51Q9__"